<template>
  <v-form>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <v-autocomplete
              v-model="currFilters.services"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="service"
              :items="services"
              :loading="loading"
              item-text="title"
              item-value="id"
              :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              @change="service = ''"
            />
          </td>
          <td>
            <v-autocomplete
              v-model="currFilters.first_name"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="first_name"
              :items="first_names"
              :loading="loading"
              item-text="name"
              item-value="name"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              clearable
            />
          </td>
          <td>
            <v-autocomplete
              v-model="currFilters.last_name"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="last_name"
              :items="last_names"
              :loading="loading"
              item-text="name"
              item-value="name"
              :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
              clearable
            />
          </td>
          <td>
            <v-menu
              ref="menuDateFrom"
              v-model="menuDateFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFrom | dateFormat"
                  :label="$t('DATA_TABLE.FILTER')"
                  append-icon="mdi-calendar"
                  clearable
                  readonly
                  role="button"
                  autocomplete="nope"
                  @click:clear="clear_from"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="dateFrom"
                min="1940-01-01"
                first-day-of-week="1"
                @change="saveDatefrom"
              />
            </v-menu>
          </td>
          <td>
            <v-menu
              ref="menuDateTo"
              v-model="menuDateTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateTo | dateFormat"
                  :label="$t('DATA_TABLE.FILTER')"
                  append-icon="mdi-calendar"
                  clearable
                  readonly
                  role="button"
                  autocomplete="nope"
                  @click:clear="clear_to"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="dateTo"
                :min="dateFrom || '1940-01-01'"
                first-day-of-week="1"
                @change="saveDateto"
              />
            </v-menu>
          </td>
          <td>
            <v-autocomplete
              v-model="currFilters.building_complex"
              :label="$t('DATA_TABLE.FILTER')"
              :search-input.sync="building_complex"
              :items="buildingComplexes"
              :loading="loading"
              item-text="name"
              item-value="id"
              :no-data-text="$t('MESSAGE.NO_DATA_FILTER_TEXT')"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
              @change="building_complex = ''"
            />
          </td>
          <td>
            <v-select
              v-model="currFilters.status"
              :items="statuses"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
            />
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn
              color="primary"
              depressed
              type="submit"
              @click.prevent="setFilters"
            >
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import { debounce, cloneDeep, isEmpty } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { BaseService } from '@/services/base.service';
import listFilters from '@/modules/_global/mixins/list-filters';

export default {
  name: 'SubscriptionsFilterForm',

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData, listFilters],

  props: {},

  data() {
    return {
      expensiveFunc: null,
      unwatch: null,
      delay: 0,

      service: null,
      services: [],

      menuDateFrom: false,
      dateFrom: null,
      menuDateTo: false,
      dateTo: null,

      first_name: null,
      first_names: [],

      last_name: null,
      last_names: [],

      building_complex: null,

      status: [],
      statuses: []
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('subscription', ['filters']),
    headers() {
      return [
        {
          text: this.$t('ABO_SERVICES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          sortable: false
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          sortable: false
        },
        {
          text: this.$t('ITEM.DATE_FROM'),
          sortable: false
        },
        {
          text: this.$t('ITEM.DATE_TO'),
          sortable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    },
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    },

    ...mapState('building_complex', ['buildingComplexes'])
  },

  watch: {
    dateTo(val) {
      if (val) {
        this.currFilters = Object.assign({}, this.currFilters, { to: val });
      } else {
        this.currFilters.to = null;
      }
    },

    dateFrom(val) {
      if (val) {
        this.currFilters = Object.assign({}, this.currFilters, {
          from: val
        });
      } else {
        this.currFilters.from = null;
      }
    },

    first_name(val) {
      if (val !== this.currFilters.first_name && !isEmpty(val)) {
        this.first_name = this.first_name.trim();
        this.expensiveFunc = this.getDataFirstNames;
        this.debouncedRequest();
      }
    },

    last_name(val) {
      if (val !== this.currFilters.last_name && !isEmpty(val)) {
        this.last_name = this.last_name.trim();
        this.expensiveFunc = this.getDataLastNames;
        this.debouncedRequest();
      }
    }
  },

  mounted() {
    if (!isEmpty(this.filters)) {
      this.currFilters = cloneDeep(this.filters);
      this.first_name = this.currFilters.first_name;
      this.getDataFirstNames();
      this.last_name = this.currFilters.last_name;
      this.getDataLastNames();
      this.status = this.currFilters.status;
      this.dateFrom = this.currFilters.from;
      this.dateTo = this.currFilters.to;
    }
    BaseService.getStatuses().then(({ data }) => {
      this.statuses = data.data;
    });
    this.getAboServices();
    this.getBuildingComplexes();
    this.setFilters();
    this.setDelay(500);
  },

  methods: {
    ...mapActions('subscription', [
      'getFilteredFirstNames',
      'getFilteredLastNames',
      'getAboServicesFilterList'
    ]),

    ...mapCacheActions('building_complex', ['getBuildingComplexes']),

    getDataBuildingComplexes() {
      this.getBuildingComplexes().catch(error => {
        this.error = error;
      });
    },

    getAboServices() {
      this.getAboServicesFilterList().then(({ data }) => {
        this.services = data.data;
      });
    },

    clear_from() {
      this.dateFrom = null;
    },
    clear_to() {
      this.dateTo = null;
    },

    saveDatefrom(date) {
      this.$refs.menuDateFrom.save(date);
    },

    saveDateto(date) {
      this.$refs.menuDateTo.save(date);
    },

    expensiveOperation: function() {
      return this.debouncedRequest();
    },

    setDelay(v) {
      this.delay = v;
    },

    getDataFirstNames() {
      this.getFilteredFirstNames({ search: this.first_name })
        .then(({ data }) => {
          this.first_names = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataLastNames() {
      this.getFilteredLastNames({ search: this.last_name })
        .then(({ data }) => {
          this.last_names = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    reset() {
      this.service = null;
      this.menuDateFrom = false;
      this.dateFrom = null;
      this.menuDateTo = false;
      this.dateTo = null;
      this.building_complex = null;

      this.first_name = null;
      this.last_name = null;

      this.status = null;

      this.currFilters = {};

      this.setFilters();
    }
  }
};
</script>
